






























































import { defineComponent } from '@vue/composition-api';
import { GlobalModel } from '@/views/model';
import { useApolloModel } from 'vue-apollo-model';

export default defineComponent({
    name: 'page-footer',
    setup(props, context) {
        const model = useApolloModel(GlobalModel);
        function goProtocol() {
            context.root.$router.push({
                path: '/platform/protocol',
            });
        }

        function goServiceProtocol() {
            context.root.$router.push({
                path: '/platform/ServiceProtocol',
            });
        }

        function goNet() {
            window.open('https://www.12377.cn/');
        }

        return {
            model,
            goNet,
            goServiceProtocol,
            goProtocol,
        };
    },
});
